export default {
  isLoading: false,
  categories: {
    isLoading: false,
    data: [],
    count: 0,
    status: null,
    error: false,
    errorMessage: null
  },
  category: {
    isLoading: false,
    data: {},
    status: null,
    error: false,
    errorMessage: null
  },
  status: null
};
